import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import { Card, CardContent, CardHeader, IconButton, Table, TableBody, TableCell, TableRow, Hidden, TextField } from '@material-ui/core';

import { NumberSpinner } from '../../../components/InputControls'
import { withRouter } from 'react-router'
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { actionUpdateGiftCrdQuantity, actionUpdateGiftCardCustomAmout, actionRemoveGiftCard } from 'actions';
import { actionRecalculateGiftCardHold } from 'actions';

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px"
    }
}));

const GiftCards = props => {

    const { className, products } = props;
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");
    const classes = useStyles();

    const giftcards = useSelector(state => state.reducerGiftCards);
    const cashless = useSelector(state => state.reducerShopCart.cashless);

    const GiftCardsTotal = () => {
        let total = 0;
        total = giftcards ? giftcards.giftcards.map(({ CartTotalAmount }) => CartTotalAmount).reduce((sum, i) => sum + i, 0) : 0;
        return total;
    }

    const changeQuantityHandler = (refrence, value) => {
        actionUpdateGiftCrdQuantity(dispatch, refrence.tourProductID, value, true);
    }


    const UpdateCustomAmout = (event) => {

        if (parseFloat(event.target.value) >= 0) {
            var gc = giftcards.giftcards.find(x => x.ProductID === parseInt(event.target.id));

            if (gc && parseFloat(event.target.value) <= gc.MaxPrice && parseFloat(event.target.value) >= gc.Price) {
                actionUpdateGiftCardCustomAmout(dispatch, parseInt(event.target.id), parseFloat(event.target.value), true);
            }

        }
    }

    const CustomGiftCardVal = (prodID) => {

        let val = false;

        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.find(x => x.ProductID === prodID) !== undefined) {
                val = giftcards.giftcards.find(x => x.ProductID === prodID).CartTotalAmount;
            }
        }

        return val;
    }

    const RemoveGC = (prodID) => {

        if (prodID > 0) {
            actionRemoveGiftCard(dispatch, prodID);

            if (cashless && cashless.length > 0) {
                actionRecalculateGiftCardHold(dispatch);
            }
        }
    }

    return (
        <Card
            key="123"
            className={classes.root + " " + classes.tourbox}
        >
            <CardHeader className={classes.tourheaderbox}
                title="Gift Cards"
                titleTypographyProps={{ color: "inherit" }}
            />
            <CardContent>
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} />
                <Table size="small" className={classes.table} aria-label="spanning table">
                    <TableBody>
                        {giftcards.giftcards.filter(x => x.CartQty > 0 || (x.MaxPrice !== undefined && x.TotalAmount > 0)).map(gc => (
                            <TableRow key={gc.ProductID}>
                                <TableCell className={classes.tablecell} align="left">
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => RemoveGC(gc.ProductID)}
                                    >
                                        <CancelIcon
                                            color={"error"}
                                        />
                                    </IconButton>
                                </TableCell>
                                <TableCell className={classes.tablecell}>{gc.ProductName}</TableCell>
                                <TableCell className={classes.tablecell} >
                                    {gc.hasOwnProperty("MaxPrice") ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            id={gc.ProductID}
                                            name="cstAmount"
                                            type="number"
                                            value={CustomGiftCardVal(gc.ProductID)} inputProps={{ pattern: "[0-9]*", min: 0, style: { textAlign: 'right' } }}
                                            style={{ width: 80 }}
                                            onChange={UpdateCustomAmout}
                                        />
                                        :
                                        <NumberSpinner refrence={{ eventId: gc.DisplayArea, tourProductID: gc.ProductID }}
                                            value={parseInt(gc.CartQty)}
                                            minValue={1} maxValue={999} steps={1}
                                            changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}
                                        ></NumberSpinner>}

                                </TableCell>
                                <Hidden smDown>
                                    {/* <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(gc.hasOwnProperty("MaxPrice") ? gc.TotalAmount : gc.Price)}</TableCell> */}
                                    <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(genfunction.priceRow(gc.hasOwnProperty("MaxPrice") ? 1 : gc.CartQty, gc.hasOwnProperty("MaxPrice") ? gc.CartTotalAmount : gc.Price))}</TableCell>
                                </Hidden>
                                <Hidden smUp>
                                    <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(genfunction.priceRow(gc.CartQty, gc.Price))}</TableCell>
                                </Hidden>
                            </TableRow>
                        ))}


                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}>Total</TableCell>
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(GiftCardsTotal())}</TableCell>
                        </TableRow>



                    </TableBody>
                </Table>
            </CardContent>
        </Card>

    )
};

export default withRouter(GiftCards);
